import { Dialog } from "primereact/dialog";
import CreateProjectView from "./CreateProjectView";
import CreateTaskView from "./CreateTaskView";
import CreateMaterialView from "./CreateMaterialView";
import CreateFullkitView from "./CreateFullkitView";
import CreatAlertView from "./CreateAlertView";
import CreateHelpNeededView from "./CreateHelpNeededView";
import CreateJobsView from "./CreateJobsView";
import "./CreateViewDialog.scss";

const CreateViewDialog = ({
  visible,
  selectedOption,
  onHide,
  isUpdateMode = false,
  settings = null,
  onSettingsSave,
  counts = [],
  reloadDashboard,
  toastRef,
}) => {
  const dialogWidth = "50vw";
  const getDialogTitle = () => {
    if (isUpdateMode) {
      return (
        <>
          Update settings for{" "}
          <strong className="capitalize">
            {selectedOption} : {settings.Title}
          </strong>
        </>
      );
    }
    return (
      <>
        Select the attributes for <strong className="capitalize">{selectedOption} </strong>module
      </>
    );
  };

  return (
    <Dialog
      header={getDialogTitle()}
      visible={visible}
      style={{ width: dialogWidth }}
      onHide={onHide}
      draggable={false}
      resizable={false}
    >
      <div className="create-view-dialog-content">
        <div className="dialog-body">
          {selectedOption === "project" && (
            <CreateProjectView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              projectCount={counts.find((obj) => obj.projectCount !== undefined)?.projectCount || 0}
              reloadDashboard={reloadDashboard}
              toastRef={toastRef}
            />
          )}
          {selectedOption === "task" && (
            <CreateTaskView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              taskCount={counts.find((obj) => obj.taskCount !== undefined)?.taskCount || 0}
              reloadDashboard={reloadDashboard}
              toastRef={toastRef}
            />
          )}
          {selectedOption === "fullkit" && (
            <CreateFullkitView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              reloadDashboard={reloadDashboard}
              fullkitCount={counts.find((obj) => obj.fullkitCount !== undefined)?.fullkitCount || 0}
              toastRef={toastRef}
            />
          )}
          {selectedOption === "alerts" && (
            <CreatAlertView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              reloadDashboard={reloadDashboard}
              alertsCount={counts.find((obj) => obj.alertsCount !== undefined)?.alertsCount || 0}
              toastRef={toastRef}
            />
          )}
          {(selectedOption === "job" || selectedOption === "jobs") && (
            <CreateJobsView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              reloadDashboard={reloadDashboard}
              jobsCount={counts.find((obj) => obj.jobCount !== undefined)?.jobCount || 0}
              toastRef={toastRef}
            />
          )}
          {selectedOption === "helpneeded" && (
            <CreateHelpNeededView
              initialSettings={settings}
              onHide={onHide}
              isUpdateMode={isUpdateMode}
              reloadDashboard={reloadDashboard}
              helpNeededCount={
                counts.find((obj) => obj.helpNeededCount !== undefined)?.helpNeededCount || 0
              }
              toastRef={toastRef}
            />
          )}
          {selectedOption === "materials" && (
            <CreateMaterialView
              initialSettings={settings}
              onHide={onHide}
              onSettingsSave={onSettingsSave}
              isUpdateMode={isUpdateMode}
              reloadDashboard={reloadDashboard}
              toastRef={toastRef}
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default CreateViewDialog;
